// extracted by mini-css-extract-plugin
module.exports = {"row":"BetonExpense_row__2KYqN","axis":"BetonExpense_axis__3A9SU","divider":"BetonExpense_divider__3DAWj","disabledFiles":"BetonExpense_disabledFiles__2N1KM"};